import { render, staticRenderFns } from "./site-popularity.vue?vue&type=template&id=420e56b2&scoped=true&"
import script from "./site-popularity.vue?vue&type=script&lang=js&"
export * from "./site-popularity.vue?vue&type=script&lang=js&"
import style0 from "./site-popularity.vue?vue&type=style&index=0&id=420e56b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e56b2",
  null
  
)

component.options.__file = "site-popularity.vue"
export default component.exports